import React from 'react';
import { List } from '../molecules';
import freshRecipesImage from '../images/recipes/types/ProductCard-Fresh-1.5.png';
import mixedRecipesImage from '../images/recipes/types/ProductCard-Mixed-1.5.png';
import dryRecipesImage from '../images/recipes/types/ProductCard-Dry-1.5.png';

export const ACCOUNT_URL = '/api/set_account/';
export const ERROR_MESSAGE = `Changes failed, please refresh the page and try again.`;
export const PAYMENT_ERROR_MESSAGE =
  'There was an error processing your credit card.';
export const TOAST_SERVER_MESSAGE =
  'Hmm. Something went wrong. Please try submitting again.';
export const TOAST_CLIENT_INCORRECT_PASSWORD_MESSAGE =
  'Current password is incorrect. Need to reset it? Click the link below.';
export const QUICK = 'quick';
export const CALENDAR = 'calendar';

const freshDescriptionList = [
  {
    heading: 'List item 1',
    body: 'Pinnacle of quality with a soft, palatable texture',
  },
  {
    heading: 'List item 2',
    body: 'Choice of four proteins and vegetable rich recipes',
  },
  {
    heading: 'List item 3',
    body: 'Portioned packs make it easy to feed the right calories',
  },
  {
    heading: 'List item 4',
    body: '100% human-grade',
  },
];
const mixedDescriptionList = [
  {
    heading: 'List item 1',
    body: 'Mix and match flavors and textures for max variety',
  },
  {
    heading: 'List item 2',
    body: 'Serve mixed, side by side, or as a topper',
  },
  {
    heading: 'List item 3',
    body: 'Up to 18% less expensive than an all Fresh diet',
  },
  {
    heading: 'List item 4',
    body: '100% human-grade',
  },
];
const bakedDescriptionList = [
  {
    heading: 'List item 1',
    body: 'Baked to preserve more nutrients and flavor than kibble',
  },
  {
    heading: 'List item 2',
    body: `Easy to store, serve and take on the go`,
  },
  {
    heading: 'List item 3',
    body: 'Up to 38% less expensive than an all Fresh diet',
  },
  {
    heading: 'List item 4',
    body: '100% human-grade',
  },
];

export const mealPrepTypes = [
  {
    title: 'FRESH',
    label: 'Select Fresh',
    value: 'fresh',
    description: (
      <>
        <p>Slow-cooked real meat and veggies.</p>
        <List items={freshDescriptionList} icon="checkmark" />
      </>
    ),

    img: {
      src: freshRecipesImage.src,
      alt: 'fresh recipe',
    },
    pricingInfo: {
      // eslint-disable-next-line no-template-curly-in-string
      price: '${{freshPrice}}/week',
    },
    benefit: 'premium',
    shouldShowMoreDetails: false,
    unavailableText:
      'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
  },
  {
    title: 'MIXED',
    label: 'Select Mixed',
    value: 'mixed',
    description: (
      <>
        <p>Half Fresh. Half Baked. Whole food.</p>
        <List items={mixedDescriptionList} icon="checkmark" />
      </>
    ),
    img: {
      src: mixedRecipesImage.src,
      alt: 'mixed recipe',
    },
    pricingInfo: {
      // eslint-disable-next-line no-template-curly-in-string
      price: '${{mixedPrice}}/week',
    },
    benefit: 'most variety',
    callout: 'new',
    shouldShowMoreDetails: false,
    unavailableText:
      'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
  },
  {
    title: 'BAKED',
    label: 'Select Baked',
    value: 'dry',
    description: (
      <>
        <p>Gently baked real meat and veggies.</p>
        <List items={bakedDescriptionList} icon="checkmark" />
      </>
    ),
    img: {
      src: dryRecipesImage.src,
      alt: 'dry recipe',
    },
    pricingInfo: {
      // eslint-disable-next-line no-template-curly-in-string
      price: '${{bakedPrice}}/week',
    },
    benefit: 'best value',
    callout: 'new',
    shouldShowMoreDetails: false,
    unavailableText:
      'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
  },
];
